<template>
  <BaseFormLayout
    :nonFieldErrors="formErrors.non_field_errors"
    :title="`${planDetails.plan_name ? planDetails.plan_name : ''}  Details`"
  >
    <template #content>
      <v-row no-gutters class="ma-0">
        <v-col cols="4" md="4" lg="3" class="white rounded-lg">
          <v-row no-gutters class="ma-0 px-4 pt-4">
            <v-col cols="12" class="pa-0 pb-2 pr-1">
              <InputField
                label="Search here.."
                prepend-inner-icon="mdi-magnify"
                v-model="searchOrderAndDriver"
                hide-details="auto"
                outlined
                dense
                clearable
                aria-autocomplete="false"
              ></InputField>
            </v-col>
            <v-col cols="12" class="pa-0 mx-0">
              <v-tabs grow v-model="tab">
                <v-tab class="caption">
                  Unassigned Orders ({{ unassignedOrderCount }})
                </v-tab>
                <v-tab class="caption">
                  Unassigned Drivers ({{
                    unassignedDriversList ? unassignedDriversList.length : 0
                  }})
                </v-tab>
              </v-tabs>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-tabs-items v-model="tab">
                <v-tab-item
                  class="overflow-y-auto px-2 w-100 background_color pt-2"
                  style="height: calc(100vh - 280px)"
                >
                  <v-card
                    v-for="(order, orderIndex) in unassignedOrderList"
                    :key="orderIndex"
                    elevation="0"
                  >
                    <div
                      :draggable="!planDetails.action_taken"
                      @dragstart="orderDragStart(order.id)"
                      class="w-100"
                    >
                      <div
                        class="px-3 py-1 ma-0 mb-2 card-box-shadow w-100"
                        v-if="order && Object.keys(order).length > 0"
                      >
                        <OrderCardHolder
                          :orderDetails="order"
                          :index="orderIndex"
                          :isChecked="selectedOrders.indexOf(order.id) > -1"
                          @sendData="isCheckboxSelected($event, order.id)"
                          @openDialog="openRejectionDialog"
                        />
                      </div>
                    </div>
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  class="overflow-y-auto px-2 pt-2 background_color"
                  style="height: calc(100vh - 280px)"
                >
                  <v-card
                    elevation="0"
                    class="px-3 py-1 ma-0 mb-2 card-box-shadow w-100"
                    v-for="(driver, driverIndex) in unassignedDriversList"
                    :key="driverIndex"
                  >
                    <DriverCardHolder :driver="driver" />
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="8" md="8" lg="9" class="px-4">
          <v-card elevation="0">
            <v-row class="ma-0">
              <v-col cols="12" class="mb-sm-3 mb-md-3 mb-lg-0 mb-xl-0">
                <v-row no-gutters>
                  <v-col
                    cols="2"
                    class="text-center font-weight-bold text-grey"
                  >
                    {{ planDetails.total_orders_count }}
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center font-weight-bold text-grey"
                  >
                    {{ planDetails.plan_orders_count }}
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center font-weight-bold text-grey"
                  >
                    {{ planDetails.performers_count }}
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center font-weight-bold text-grey"
                  >
                    {{ planDetails.display_distance }}
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center font-weight-bold text-grey"
                  >
                    {{ planDetails.total_travelling_time }}
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center font-weight-bold text-grey"
                  >
                    {{ planDetails.plan_date }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col
                    cols="2"
                    class="text-center text-caption text-grey text-capitalize"
                  >
                    Total Orders
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center text-caption text-grey text-capitalize"
                  >
                    Total Planned Orders
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center text-caption text-grey text-capitalize"
                  >
                    Total Trips
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center text-caption text-grey text-capitalize"
                  >
                    Total Distance
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center text-caption text-grey text-capitalize"
                  >
                    Total Travelling Time
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center text-caption text-grey text-capitalize"
                  >
                    Plan Date
                  </v-col>
                </v-row>
                <v-row no-gutters class="pt-2">
                  <v-col
                    cols="2"
                    class="text-center font-weight-bold text-grey"
                  >
                    {{ planDetails.fleet_capacity_utilization }}%
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center font-weight-bold text-grey"
                  >
                    {{ planDetails.planned_locations_count }}
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center font-weight-bold text-grey"
                  >
                    {{ planDetails.customer_address_count }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col
                    cols="2"
                    class="text-center text-caption text-grey text-capitalize"
                  >
                    Avg. Fleet utilization
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center text-caption text-grey text-capitalize"
                  >
                    Total Drop Points
                  </v-col>
                  <v-col
                    cols="2"
                    class="text-center text-caption text-grey text-capitalize"
                  >
                    Total Customers
                  </v-col>
                  <v-col cols="3" class="d-flex justify-end align-center">
                    <PrimaryButton
                      small
                      btnClass="mr-2"
                      @click="viewOrdersOnMap"
                      name="View Orders on Map"
                      icon="mdi-map-marker"
                      iconSize="small"
                    >
                    </PrimaryButton>
                  </v-col>
                  <v-col
                    cols="3"
                    class="text-center text-caption text-grey text-capitalize app-search-input-white"
                  >
                    <InputField
                      v-model="tripSearch"
                      label="search"
                      outlined
                      dense
                      hide-details="auto"
                      clearable
                      @input="searchTripOrder"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
          <v-row no-gutters class="ma-0 pt-4">
            <v-col cols="12" class="order-trip-container">
              <v-expansion-panels
                v-for="(trip, tripIndex) in tripList"
                :key="tripIndex"
                flat
                class="mb-3"
              >
                <TripExpansionPanel
                  :tripType="trip.trip_type"
                  :tripIndex="tripIndex"
                  v-model="tripList[tripIndex]"
                  :tripErrors="tripErros[tripIndex]"
                  :headerClass="
                    isAvailableTripOrder[tripIndex]
                      ? 'subHeading text_color--text'
                      : trip.action_taken
                      ? 'unassigned'
                      : 'primary white--text'
                  "
                  @removeOrderFromTrip="removeOrderFromTrip"
                  @orderDragStart="orderDragStart"
                  @dropOrder="drop"
                  @removeTrip="removeTrip(trip, tripIndex)"
                  @viewTripOnMap="viewTripOnMap"
                  @createSingleTrip="createSingleTrip"
                />
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <PlanTripRouteInfoDialog v-model="openTripViewDialog" :tripID="tripID" />
      <TripOrderReason
        v-model="openOrderRejectDialog"
        :reason="rejectationReason"
      />
      <v-dialog v-model="showMapDialog" eager>
        <v-card>
          <v-card-title class="primary white--text">
            Orders on Map
            <v-spacer></v-spacer>
            <v-btn icon depressed @click="closePlannedOrderDialog">
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-0 ma-0">
            <GoogleMap
              mapWidth="100%"
              :mapHeight="containerHeight"
              ref="viewTrip"
              mapId="viewTrip"
              :clusterMarkers="true"
              :hasMapInfo="true"
            >
              <template #mapInfo>
                <MapInfo
                  legendType="planned_unplanned_orders"
                  ref="mapInformation"
                  @plannedLocation="plannedLocation"
                  @unplannedLocation="unplannedLocation"
                />
              </template>
            </GoogleMap>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </BaseFormLayout>
</template>

<script>
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import TripExpansionPanel from "@/components/ModuleBasedComponents/TripPlanning/TripExpansionPanel.vue";
import OrderCardHolder from "@/components/ModuleBasedComponents/TripPlanning/OrderCardHolder.vue";
import { bus } from "@/main";
import { returnToday } from "@/utils/functions";
import DriverCardHolder from "@/components/ModuleBasedComponents/TripPlanning/DriverCardHolder.vue";
import PlanTripRouteInfoDialog from "@/components/ModuleBasedComponents/TripPlanning/PlanTripRouteInfoDialog.vue";
import TripOrderReason from "@/components/ModuleBasedComponents/TripPlanning/TripOrderReason.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";

export default {
  components: {
    BaseFormLayout,
    OrderCardHolder,
    TripExpansionPanel,
    DriverCardHolder,
    PlanTripRouteInfoDialog,
    TripOrderReason,
    GoogleMap,
    MapInfo,
  },
  data() {
    return {
      returnToday,
      tripList: [],
      vehicleList: [],
      driverList: [],
      formErrors: {},
      tripDate: null,
      selectedOrderId: null,
      selectedTripIndex: null,
      // selectedOrderIds: [],
      keyUpdate: 0,

      showMapDialog: false,

      planDetails: {},
      tripErros: [],
      unassignedDrivers: [],
      unassignedOrders: [],
      selectedOrders: [],
      tripSearch: null,
      tab: 0,
      isAvailableTripOrder: [],

      searchOrderAndDriver: null,

      tripMapData: null,
      tripRouteData: {},
      openTripViewDialog: false,
      selectedTrip: null,

      openOrderRejectDialog: false,
      rejectationReason: null,

      allOrderList: [],
      orderExpansion: [],
      isVisiblePlanned: true,
      isVisibleUnplanned: true,
      tripID: null,
    };
  },
  computed: {
    containerHeight() {
      return `${window.innerHeight - 170}px`;
    },
    unassignedOrderList() {
      if (
        this.searchOrderAndDriver &&
        this.unassignedOrders &&
        this.unassignedOrders.length > 0 &&
        this.tab == 0
      ) {
        return this.unassignedOrders.filter((obj) => {
          return Object.values(obj)
            .map((p) => {
              return typeof p === "string"
                ? p
                    .toLocaleLowerCase()
                    .indexOf(this.searchOrderAndDriver.toLocaleLowerCase()) > -1
                : false;
            })
            .includes(true);
        });
      } else {
        return this.unassignedOrders;
      }
    },
    unassignedOrderCount() {
      return this.unassignedOrderList.filter((v) => v != null)?.length;
    },
    unassignedDriversList() {
      if (
        this.searchOrderAndDriver &&
        this.unassignedDrivers &&
        this.unassignedDrivers.length > 0 &&
        this.tab == 1
      ) {
        return this.unassignedDrivers.filter((obj) => {
          return Object.values(obj)
            .map((p) => {
              return typeof p === "string"
                ? p
                    .toLocaleLowerCase()
                    .indexOf(this.searchOrderAndDriver.toLocaleLowerCase()) > -1
                : false;
            })
            .includes(true);
        });
      } else {
        return this.unassignedDrivers;
      }
    },
  },
  methods: {
    closePlannedOrderDialog() {
      let timer = setInterval(() => {
        if (this.$refs.mapInformation) {
          this.$refs.mapInformation.resetInfo();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(timer);
      }, 1000);

      this.showMapDialog = false;
    },
    setMarkers() {
      let orders = [];
      if (this.isVisiblePlanned && this.isVisibleUnplanned) {
        orders = this.allOrderList;
      } else if (this.isVisiblePlanned) {
        orders = this.allOrderList.filter((item) => item.is_planned);
      } else if (this.isVisibleUnplanned) {
        orders = this.allOrderList.filter((item) => item.is_planned == false);
      } else {
        orders = [];
      }
      if (orders && orders.length > 0) {
        this.$refs.viewTrip.clearMarker();
        this.$refs.viewTrip.addMultipleMarkers(orders, "", true, [
          "coordinates",
          "is_planned",
        ]);
      } else {
        this.$refs.viewTrip.clearMarker();
      }
    },
    plannedLocation(val) {
      this.isVisiblePlanned = val;
      this.setMarkers();
    },
    unplannedLocation(val) {
      this.isVisibleUnplanned = val;
      this.setMarkers();
    },
    viewOrdersOnMap() {
      bus.$emit("showLoader", true);
      this.$api.tripPlanning
        .getAllOrderData(this.$route.params.id)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.allOrderList = res.data;
          this.showMapDialog = true;
          let timer = setInterval(() => {
            if (this.$refs.viewTrip) {
              clearInterval(timer);
              this.$refs.viewTrip.addMultipleMarkers(
                this.allOrderList,
                "",
                true,
                ["coordinates", "is_planned"]
              );
            }
          }, 100);
          setTimeout(() => {
            clearInterval(timer);
          }, 1000);
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          if (err.message) {
            bus.$emit("showToastMessage", {
              message: err.message,
              color: "error",
            });
          } else {
            bus.$emit("showToastMessage", {
              message: "Error Fetching data!",
              color: "error",
            });
          }
        });
    },
    isCheckboxSelected(isChecked, orderId) {
      if (isChecked) {
        this.selectedOrders.push(orderId);
      } else {
        this.selectedOrders.splice(this.selectedOrders.indexOf(orderId), 1);
      }
    },
    openRejectionDialog(reason) {
      this.openOrderRejectDialog = true;
      this.rejectationReason = reason;
    },
    searchTripOrder() {
      if (this.tripOrderSearchTimeout) {
        clearTimeout(this.tripOrderSearchTimeout);
      }
      let searchText = "";
      if (this.tripSearch && this.tripSearch.trim()) {
        searchText = this.tripSearch.trim().toLowerCase();
      }
      this.tripOrderSearchTimeout = setTimeout(() => {
        this.isAvailableTripOrder = this.tripList.map((trip) => {
          if (searchText) {
            return trip.planned_orders.some((order) => {
              return (
                (order.reference_number &&
                  order.reference_number.toLowerCase().indexOf(searchText) >
                    -1) ||
                (order.customer_name &&
                  order.customer_name.toLowerCase().indexOf(searchText) > -1) ||
                (order.address &&
                  order.address.toLowerCase().indexOf(searchText) > -1)
              );
            });
          } else {
            return false;
          }
        });
      }, 500);
    },
    viewTripOnMap(trip) {
      this.tripID = trip.id;
      this.openTripViewDialog = true;
      // console.log(trip);
      // // let trip_info = {
      // //   total_orders: trip.orders_count,
      // //   distance: trip.distance,
      // //   travelling_time: trip.travelling_time,
      // //   total_time: trip.total_time,
      // // };
      // // this.tripMapData = trip_info;

      // // this.selectedTrip = trip;
      // // this.selectedTrip.trip_info = trip_info;
      // // bus.$emit("showLoader", true);
      // this.$api.tripPlanning
      //   .getPlanTripRouteData(trip.id)
      //   .then((res) => {
      //     bus.$emit("showLoader", false);
      //     this.tripRouteData = res.data;
      //     console.log(this.tripRouteData);
      //     this.openTripViewDialog = true;

      //     // console.log( this.tripRouteData)
      //     // if (
      //     //   this.tripRouteData &&
      //     //   this.tripRouteData.warehouse_details &&
      //     //   this.tripRouteData.order_details
      //     // ) {
      //     //   this.tripRouteData.order_details.push({
      //     //     ...this.tripRouteData.warehouse_details,
      //     //     location_type: "Loading",
      //     //     name: "Warehouse",
      //     //   });
      //     // }
      //   })
      //   .catch((err) => {
      //     bus.$emit("showLoader", false);
      //     if (err.message) {
      //       bus.$emit("showToastMessage", {
      //         message: err.message,
      //         color: "error",
      //       });
      //     } else {
      //       bus.$emit("showToastMessage", {
      //         message: "Error Fetching data!",
      //         color: "error",
      //       });
      //     }
      //   });
    },
    createSingleTrip(trip, tripIndex) {
      let payload = {
        orders: [...trip.planned_orders.map((order) => order.id)],
      };
      this.$api.tripPlanning
        .createSingleTrip(trip.id, payload)
        .then(() => {
          // this.tripList.splice(tripIndex, 1);
          this.getAllData();
          bus.$emit("showToastMessage", {
            message: "Trip created successfully!",
            color: "success",
          });
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          bus.$emit("showToastMessage", {
            message: err.message ? err.message : "Error Performing action!",
            color: "error",
          });
          bus.$emit("showLoader", false);
        });
    },
    async removeTrip(trip, tripIndex) {
      this.$root
        .$confirm("Delete?", "Are you sure you want to delete trip?", {
          color: "error",
        })
        .then((confirm) => {
          if (confirm) {
            bus.$emit("showLoader");
            this.$api.tripPlanning
              .deletePlannedTrip(trip.id)
              .then(() => {
                this.tripList.splice(tripIndex, 1);
                bus.$emit("showToastMessage", {
                  message: "Trip removed successfully!",
                  color: "success",
                });
                this.getTripPlanDetails(this.$route.params.id);
                this.getPlannedTripList({ trip_plan: this.$route.params.id });
              })
              .catch((err) => {
                console.error(err);
                bus.$emit("showToastMessage", {
                  message: "Couldn't delete trip!",
                  color: "error",
                });
              });
          }
        });
    },
    async removeOrderFromTrip(orderId, tripIndex) {
      let orderObject = await this.getOrderObject(orderId, tripIndex);
      this.keyUpdate++;
      let indexToPushOn = 0;
      let deleteCount = 0;
      if (orderObject && orderObject.oldIndex) {
        indexToPushOn = orderObject.oldIndex;
        deleteCount = 1;
      }
      this.unassignedOrders.splice(indexToPushOn, deleteCount, orderObject);
      this.$forceUpdate();
    },
    orderDragStart(id, tripIndex = null) {
      this.selectedOrderId = id;
      if (tripIndex != null) {
        this.selectedTripIndex = tripIndex;
      }
    },
    async drop(tripIndex, tripOrderIndex) {
      let orderObject;
      if (this.selectedOrders.length) {
        while (this.selectedOrders.length) {
          let orderId = this.selectedOrders.pop();
          orderObject = await this.getOrderObject(
            orderId,
            this.selectedTripIndex
          );
          this.moveOrderToTrip(orderObject, tripIndex, tripOrderIndex);
        }
      } else {
        orderObject = await this.getOrderObject(
          this.selectedOrderId,
          this.selectedTripIndex
        );
        this.moveOrderToTrip(orderObject, tripIndex, tripOrderIndex);
      }
      this.selectedTripIndex = null;
    },
    async getOrderObject(orderId, tripIndex) {
      if (tripIndex != null) {
        let order;
        let orderIndex = this.tripList[tripIndex].planned_orders.findIndex(
          (order) => order && order.id == orderId
        );
        order = this.tripList[tripIndex].planned_orders.splice(
          orderIndex,
          1
        )[0];
        // this.keyUpdate++;
        return order;
      } else {
        let orderIndex = this.unassignedOrders.findIndex(
          (order) => order && order.id == orderId
        );
        let orderObject = this.unassignedOrders.splice(orderIndex, 1, null)[0];
        orderObject.oldIndex = orderIndex;
        return orderObject;
      }
    },
    moveOrderToTrip(order, tripIndex, tripOrderIndex = 0) {
      this.tripList[tripIndex].planned_orders.splice(tripOrderIndex, 0, order);
    },
    getVehicleList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
      };
      this.$api.vehicle
        .getVehicleList(params)
        .then((res) => {
          this.vehicleList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    async getUnplannedDriverList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        planned_performers: false,
        limit: "all",
      };
      await this.$api.tripPlanning
        .getUnplannedDriverList(params)
        .then((res) => {
          this.unassignedDrivers = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    async getUnplannedOrderListList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        planned_orders: false,
        limit: "all",
      };
      await this.$api.tripPlanning
        .getUnplannedOrderListList(params)
        .then((res) => {
          this.unassignedOrders = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    async getPlannedTripList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        ...params,
        limit: "all",
      };
      await this.$api.tripPlanning
        .getPlannedTripList(params)
        .then((res) => {
          this.tripList = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    async getTripPlanDetails(id) {
      bus.$emit("showLoader", true);
      await this.$api.tripPlanning
        .getTripPlanningDetails(id)
        .then((res) => {
          this.planDetails = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    async getAllData() {
      if (
        this.$route.params &&
        this.$route.params.id &&
        !isNaN(this.$route.params.id)
      ) {
        await this.getTripPlanDetails(this.$route.params.id);
        await this.getPlannedTripList({ trip_plan: this.$route.params.id });
        await this.getUnplannedDriverList({ trip_plan: this.$route.params.id });
        await this.getUnplannedOrderListList({
          trip_plan: this.$route.params.id,
        });
      }
    },
  },
  mounted() {
    this.getAllData();
  },
};
</script>

<style lang="scss" scoped>
.order-trip-container {
  height: calc(100vh - 320px);
  overflow-y: auto;
}

.v-expansion-panel-content__wrap {
  padding: 0px;
}
.expansion-container-margin {
  margin: 2px;
}

.drop-container-expansion {
  min-height: 150px;
}
.box-shadow-none::before {
  box-shadow: none !important;
}
</style>
